import api from '../../api'

const LOGIN_CLEAR = 'LOGIN_CLEAR'
const LOGIN_FAILURE = 'LOGIN_FAILURE'
const LOGIN_BEGIN = 'LOGIN_BEGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGOUT = 'LOGOUT'

const USER_SET = 'USER_SET'
const USER_CLEAR = 'USER_CLEAR'

const initialState = {
	authenticating: false,
	user: null,
	error: false,
	errorMessage: null
}

const actions = {
	initialize({commit}) {

		return api.auth.testLogin()
			.then(function ({data}) {
				if (!data.user) {
					throw Error('No user')
				}
				commit(USER_SET, data.user)
			})
			.then(function () {
				commit(LOGIN_SUCCESS)
			})
			.catch(function (error) {
				commit(LOGOUT)
			})
	},

	login({commit}, {username, password, login_as_username}) {
		commit(LOGIN_BEGIN)

		return api.auth.login(username, password, login_as_username)
			.then(function ({data}) {

				if (!data.user) {
					throw Error('No user')
				}
				commit(USER_SET, data.user)
			})
			.then(function () {
				commit(LOGIN_SUCCESS)
			})
			.catch(function (error) {
				commit(LOGIN_FAILURE, error)
				throw error
			})
	},
	logout({commit}) {
		return api.auth.logout()
			.then(function () {
				// TODO: возможно нужно еще что-то почистить
				commit(LOGOUT)
			})
			.finally(function () {
				commit(USER_CLEAR)
			})
	}
}


const mutations = {
	[LOGIN_BEGIN](state) {
		state.authenticating = true
		state.error = false
	},

	[LOGIN_FAILURE](state, error) {
		state.authenticating = false
		state.error = true

		let error_message = null
		try {
			error_message = error['response']['data']['detail']
		} catch {
		}

		if (error_message == null) {
			error_message = error
		}

		state.errorMessage = error_message
	},

	[LOGIN_SUCCESS](state) {
		state.authenticating = false
		state.error = false
		state.errorMessage = null
	},

	[LOGOUT](state) {
		state.user = null
		state.authenticating = false
		state.error = false
		state.errorMessage = null
	},

	[USER_SET](state, user) {
		state.user = user
	},

	[USER_CLEAR](state, user) {
		state.user = null
	},
}

export default {
	namespaced: true,
	state: initialState,
	getters: {

		authenticating: function (state) {
			return state.authenticating
		},
		isAuthenticated: function (state) {
			return !!state.user
		},

		error: function (state) {
			return state.error
		},

		user: function (state) {
			return state.user
		},

		errorMessage: function (state) {
			return state.errorMessage
		}
	},
	actions,
	mutations
}